var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDissatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 12,
    r: 9,
    fill: "#FFCF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 11C16.528 11 17.2 10.328 17.2 9.5C17.2 8.672 16.528 8 15.7 8C14.872 8 14.2 8.672 14.2 9.5C14.2 10.328 14.872 11 15.7 11Z",
    fill: "#1A1B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 11C9.528 11 10.2 10.328 10.2 9.5C10.2 8.672 9.528 8 8.7 8C7.872 8 7.2 8.672 7.2 9.5C7.2 10.328 7.872 11 8.7 11Z",
    fill: "#1A1B43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 2C6.67 2 2.2 6.48 2.2 12C2.2 17.52 6.67 22 12.19 22C17.71 22 22.2 17.52 22.2 12C22.2 6.48 17.72 2 12.19 2ZM12.2 20C7.78 20 4.2 16.42 4.2 12C4.2 7.58 7.78 4 12.2 4C16.62 4 20.2 7.58 20.2 12C20.2 16.42 16.62 20 12.2 20Z",
    fill: "#1A1B43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19997 17.0001C8.90197 17.0001 8.60697 16.8671 8.40997 16.6141C8.07097 16.1771 8.14997 15.5501 8.58597 15.2111C10.61 13.6391 13.791 13.6381 15.814 15.2111C16.251 15.5501 16.329 16.1781 15.99 16.6141C15.65 17.0511 15.021 17.1291 14.587 16.7901C13.262 15.7611 11.139 15.7611 9.81397 16.7901C9.63097 16.9321 9.41397 17.0001 9.19997 17.0001Z",
    fill: "#1A1B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDissatisfied);
export default __webpack_public_path__ + "static/media/icon-dissatisfied.e81e8e1ace504eb8ac4fd9e54e6aaf44.svg";
export { ForwardRef as ReactComponent };